import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionDataService
{

  get DataLogical(): string 
  {
    let dataLogical = sessionStorage.getItem(StorageKeys.DataLogical);

    if (dataLogical !== null)
    {
      return dataLogical;
    }
  }
  set DataLogical(dataLogical: string) { sessionStorage.setItem(StorageKeys.DataLogical, dataLogical); }

  get CustId(): string 
  {
    let custId = sessionStorage.getItem(StorageKeys.CustId);

    if (custId !== null)
    {
      return custId;
    }
  }
  set CustId(custId: string) { sessionStorage.setItem(StorageKeys.CustId, custId); }

  get EmployeeId(): string 
  {
    let employeeId = sessionStorage.getItem(StorageKeys.EmployeeId);

    if (employeeId !== null)
    {
      return employeeId;
    }
  }
  set EmployeeId(employeeId: string) { sessionStorage.setItem(StorageKeys.EmployeeId, employeeId); }

  get IsEmployee(): boolean 
  {
    let isEmployee = sessionStorage.getItem(StorageKeys.IsEmployee);

    if (isEmployee !== null)
    {
      return isEmployee === "true";
    }
  }
  set IsEmployee(isEmployee: boolean) { sessionStorage.setItem(StorageKeys.IsEmployee, isEmployee.toString()); }

  //Client version doesn't require getting/setting as we don't want to modify it's value during runtime
  public ClientVersion: string = "1.0.81.3";

  /**
   * Clears all session variables
   */
  public flush(): void
  {
    sessionStorage.clear();
  }
}

class StorageKeys 
{
  public static DataLogical: string = "DataLogical";
  public static CustId: string = "CustId";
  public static EmployeeId: string = "EmployeeId";
  public static IsEmployee: string = "IsEmployee";
}
